export const contactInfo = {
  phone: {
    primary: '+91 97694 15432',
    primaryLink: '919769415432',
    alternate: '+91 97694 15432',
    alternateLink: '919769415432',
    telephone: '022-35764548'
  },
  email: {
    primary: 'akylegalconsultants@gmail.com'
  },
  address: {
    line1: 'Chamber No. 01, Building No. 03, Sector-5,',
    line2: 'Shanti Garden, Near MBVV Police Commissioner Office,',
    line3: 'Mira Road (E), Thane-401 107',
    city: 'Mumbai',
    state: 'Maharashtra',
    pincode: '401107',
    country: 'India',
    workingHours: {
      days: 'Monday to Saturday',
      time: '10:30 AM to 7:30 PM'
    }
  },
  address2: {
    line1: 'Shop No. 30, Celeste, JP North,',
    line2: 'Vinay Nagar, Mira Road (E),',
    line3: 'Thane-401 107',
    city: 'Mumbai',
    state: 'Maharashtra',
    pincode: '401107',
    country: 'India',
    workingHours: {
      days: 'Monday to Saturday',
      time: '10:30 AM to 7:30 PM'
    }
  },
  socialMedia: {
    facebook: 'https://facebook.com/',
    twitter: 'https://twitter.com/',
    linkedin: 'https://linkedin.com/',
    instagram: 'https://instagram.com/',
    youtube: 'https://youtube.com/'
  }
};
